import styled, { css } from 'styled-components';

const SubmissionSuccessStyled = styled.section.attrs({
  className: 'newsletters__page__success'
})`
  ${props => {
    const { theme = {} } = props;
    const { media = {} } = theme;
    return css`
      position: relative;
      background: #f4f4f4;

      .head,
      .subhead {
        text-align: center;
      }

      .head {
        font: 700 21px/35px 'CentraNo2', sans-serif;
        padding-top: 27px;

        ${media.sm.up} {
          font-size: 35px;
          margin-bottom: 16px;
          padding-top: 44px;
        }

        ${media.md.up} {
          padding-top: 65px;
        }
      }

      .subhead {
        font: 400 16px/20px 'CentraNo2', sans-serif;
        max-width: 30ch;
        margin: 0 auto;
        margin-bottom: 35px;

        ${media.sm.up} {
          max-width: unset;
          font-size: 18px;
          margin: 0 57px;
          margin-bottom: 48px;
        }

        ${media.md.up} {
          margin-bottom: 70px;
        }
      }

      .card-wrapper {
        background-color: #f4f4f4;
        padding-bottom: 40px;

        ${media.sm.up} {
          padding-bottom: 28px;
        }

        ${media.md.up} {
          &.loaded {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            grid-gap: 0 40px;
            max-width: 920px;
            margin: auto;
          }
        }

        .card--default {
          .card__title {
            font: 700 16px/17px 'CentraNo2', sans-serif;
          }

          .eyebrow {
            display: block;
            font-family: 'CentraNo2', sans-serif;
            font-weight: 700;
          }

          ${media.sm.up} {
            border: none;
            margin: 0 57px;
            &:first-child {
              border-top: 0.0625rem solid #ccc;
              padding-top: 32px;
            }
          }

          ${media.md.up} {
            margin: 0;
            padding: 0;

            &:first-child {
              border-top: none;
              padding: 0;
            }
          }
        }
      }
    `;
  }};
`;

SubmissionSuccessStyled.displayName = 'SubmissionSuccessSection';

export default SubmissionSuccessStyled;
